import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Clipboard from 'clipboard';
import { checkCsv, submitUserConfirmation, handleFailedSubmit } from '../../../actions/website/FileUploadActions';
import { hideModal } from '../../../actions/ModalActions';
import AddGuestGroupForm from './AddGuestGroupFormV2';
import { Tabs, Pane } from '../../common/ui/tabs';
import FileInputButton from '../../common/form/FileInputButton';


function AddGuestGroup({ callback, guestGroupTemplate }) {
  return (
    <div className="add-guest-tab enter-individually">
      <div className="row">
        <div className="col-xs-12">
          <AddGuestGroupForm template={guestGroupTemplate} callback={callback} />
        </div>
      </div>
    </div>
  );
}

AddGuestGroup.propTypes = {
  callback: PropTypes.func,
  guestGroupTemplate: PropTypes.string,
};

class SendLink extends Component {
  constructor(props) {
    super(props);

    this.initializeClipboard = this.initializeClipboard.bind(this);
    this.destroyClipboard = this.destroyClipboard.bind(this);

    this.state = {
      clipboard: undefined,
      isClipboardSupported: Clipboard.isSupported(),
      clipboardErrorMessage: undefined,
    };
  }

  componentDidMount() {
    this.initializeClipboard();
  }

  componentWillUnmount() {
    this.destroyClipboard();
  }

  initializeClipboard() {
    const clipboard = new Clipboard('#send-address-link-modal-copy');

    clipboard.on('success', (e) => {
      const target = e.trigger;
      const currentButtonText = target.innerText;
      target.innerText = 'Copied!';
      target.disabled = true;
      setTimeout(() => {
        target.innerText = currentButtonText;
        target.disabled = false;
      }, 1000);
    });

    clipboard.on('error', () => {
      let clipboardErrorMessage = '';
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Select and copy.';
      } else if (/Mac/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Press ⌘-C to copy.';
      } else {
        clipboardErrorMessage = 'Press Ctrl-C to copy.';
      }
      this.setState({ clipboardErrorMessage });
      setTimeout(() => this.setState({ clipboardErrorMessage: undefined }), 5000);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  render() {
    const { hashId, closeModal } = this.props;
    const { isClipboardSupported, clipboardErrorMessage } = this.state;

    return (
      <div className="add-guest-tab send-link">
        <h3>Send a Link to Guests</h3>
        <p className="add-guest-tab-description">They’ll fill out a form and we’ll add their information to Guest List for you. To avoid duplicates, only send this link to guests you haven’t added to Guest List yet.</p>
        <div className="add-guest-tab-input">
          <div className="add-guest-tab-addr">
            <h4>{`${window.location.protocol}//${window.location.host}/addr/${hashId}`}</h4>
          </div>
          <p className="add-guest-tab-input-label">Want to see what your guests will see? <a href={`/addr/${hashId}`} className="text-button" target="_blank" rel="noopener noreferrer">Preview&nbsp;the&nbsp;link&nbsp;&rsaquo;</a></p>
        </div>
        <div className="add-guest-buttons">
          {isClipboardSupported && (
            <button id="send-address-link-modal-copy" className="btn btn-primary btn-wide btn-left" data-clipboard-text={`${window.location.protocol}//${window.location.host}/addr/${hashId}`}>Copy Link</button>
          )}
          {clipboardErrorMessage && (
            <div className="help-block">{clipboardErrorMessage}</div>
          )}
          <button className="btn btn-secondary btn-wide btn-right" onClick={closeModal}>Done</button>
        </div>
      </div>
    );
  }
}

SendLink.propTypes = {
  hashId: PropTypes.string,
  closeModal: PropTypes.func,
};

class UploadSpreadsheet extends Component {
  constructor(props) {
    super(props);

    this.processError = this.processError.bind(this);
    this.checkCsvFormat = this.checkCsvFormat.bind(this);
    this.handleError = this.handleError.bind(this);

    this.state = {
      busy: false,
      error: undefined,
      fileInputKey: 1,
    };
  }

  processError(error) {
    let errorMessage;
    if (error.category && error.category.domain === 'bulk-import') {
      switch (error.category.reason) {
        case 'unknown-column':
          errorMessage = `Your file contains an unknown column. Please remove ${error.trigger}, and try again. Use the Zola provided .csv spreadsheet column names.`;
          break;
        case 'missing-column':
          errorMessage = `Your file contains a missing column. Please add ${error.trigger}, and try again. Use the Zola provided .csv spreadsheet column names.`;
          break;
        case 'primary-name-missing':
          errorMessage = `You are missing a First Name or Last Name in row ${_.toInteger(error.trigger) + 1}. Please add the guest’s name, and try again.`;
          break;
        case 'illegal-characters':
          errorMessage = `Row ${_.toInteger(error.trigger) + 1} contains "[];<>{}\\". Please remove, and try again.`;
          break;
        case 'row-length':
          errorMessage = `Row ${_.toInteger(error.trigger) + 1} contains too many columns. Please use the Zola provided .csv spreadsheet columns and do not add text beyond those columns.`;
          break;
        case 'wrong-file-type':
          errorMessage = 'Please use the Zola provided .csv spreadsheet to import your guest list.  Make sure to save your file as a .csv.';
          break;
        case 'extra-column':
          errorMessage = 'Your file contains a blank column. Please use the Zola provided .csv spreadsheet columns and do not add text beyond those columns.';
          break;
        case 'parsing-failed':
        default:
          errorMessage = 'There was an error uploading your file. Please use the Zola provided .csv spreadsheet column names and try again.';
      }
    } else {
      errorMessage = 'There was an error uploading your file. Please use the Zola provided .csv spreadsheet column names and try again.';
    }

    this.setState({
      error: errorMessage,
      fileInputKey: this.state.fileInputKey + 1
    });
  }

  handleError() {
    const { handleErrorState } = this.props;

    this.setState({
      referenceKey: '',

    }, () => {
      handleErrorState(this.state.referenceKey);
    });
  }

  checkCsvFormat(file, guestsInGuestList) {
    const { onFileCheck } = this.props;
    return onFileCheck(file, guestsInGuestList)
      .catch(error => error.response.json().then(this.processError));
  }

  render() {
    const { error, fileInputKey } = this.state;
    const { guestsInGuestList, callback } = this.props;
    return (
      <div>
        <div className="add-guest-tab upload-spreadsheet">
          <h3>Upload a Spreadsheet</h3>
          <p className="add-guest-tab-description">
            Download the empty template and add your guests&#39; information.<br />
            <em>Do not add, edit, or delete</em> columns on the template or it will not upload.<br />
            When finished, save as a .csv and upload it here.
          </p>
          {error && (
            <p className="text-danger margin-bottom-2x">{error}</p>
          )}
          <div className="add-guest-tab-buttons">
            <a href="/weddings-files/zola_guest_list_template.csv" className="btn btn-secondary btn-left">Download Empty Template</a>
            <FileInputButton
              key={fileInputKey}
              btnClass="btn-primary btn-right"
              inputId="csv_upload"
              types="text/csv"
              onSelect={file => this.checkCsvFormat(file, guestsInGuestList)}
              btnText="Upload Spreadsheet"
              onCheckDuplicates={this.checkDuplicates}
              callback={callback}
            />
          </div>
          <p className="help-cta text-muted">
            Need help? <a href="https://help.zola.com/hc/articles/115002148812-How-do-I-use-the-guest-list-import-tool" className="text-button" target="_blank" rel="noopener noreferrer">Visit our FAQs &rsaquo;</a>
          </p>
        </div>
      </div>
    );
  }
}

UploadSpreadsheet.propTypes = {
  onFileCheck: PropTypes.func,
  handleErrorState: PropTypes.func,
  guestsInGuestList: PropTypes.arrayOf(
    PropTypes.number
  ),
  callback: PropTypes.func,
};


const TAB_NAME_TO_INDEX = {
  ENTER_INDIVIDUALLY: 0,
  SEND_LINK: 1,
  UPLOAD_SPREADSHEET: 2,
};

class AddGuestGroupModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      guestGroupTemplate: props.guestGroupType || 'SINGLE',
      busy: false
    };
  }

  render() {
    const { account, onFileCheck, closeModal, callback, activeTab, handleUpload, busy, handleErrorState, guestsInGuestList, sendLinkVisible } = this.props;
    const { guestGroupTemplate } = this.state;

    return (
      <div id="add-guest-group-modal-v2">
        <div className="modal-header">
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-6">
              <h3 className="modal-title margin-bottom">Add Guests</h3>
            </div>
          </div>
        </div>
        <div className="modal-body">
          <Tabs selected={TAB_NAME_TO_INDEX[activeTab] || 0}>
            <Pane label="Enter Individually">
              <AddGuestGroup guestGroupTemplate={guestGroupTemplate} callback={callback} />
            </Pane>
            {(sendLinkVisible == null || sendLinkVisible)
              && (
              <Pane label="Send a Link">
                <SendLink hashId={account.hash_id} closeModal={closeModal} />
              </Pane>
              )
            }
            <Pane label="Upload a Spreadsheet">
              <UploadSpreadsheet
                busy={busy}
                onFileCheck={onFileCheck}
                closeModal={closeModal}
                handleUpload={handleUpload}
                handleErrorState={handleErrorState}
                guestsInGuestList={guestsInGuestList}
                callback={callback}
              />
            </Pane>
          </Tabs>
        </div>
      </div>
    );
  }
}

AddGuestGroupModal.propTypes = {
  account: PropTypes.shape({
    hash_id: PropTypes.string
  }),
  onFileCheck: PropTypes.func,
  closeModal: PropTypes.func,
  guestGroupType: PropTypes.string,
  callback: PropTypes.func,
  activeTab: PropTypes.string,
  handleUpload: PropTypes.func,
  busy: PropTypes.bool,
  handleErrorState: PropTypes.func,
  guestsInGuestList: PropTypes.arrayOf(
    PropTypes.number
  ),
  sendLinkVisible: PropTypes.bool
};

const mapStateToProps = state => ({
  account: state.wedding.account,
  busy: state.modal.busy,
  guestsInGuestList: state.guestList.guests.orderedIds
});

const mapDispatchToProps = dispatch => ({
  onFileCheck: (file, guestsInGuestList) => dispatch(checkCsv(file, guestsInGuestList)),
  handleUpload: () => dispatch(submitUserConfirmation()),
  closeModal: () => dispatch(hideModal()),
  handleErrorState: referenceKey => dispatch(handleFailedSubmit(referenceKey))
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddGuestGroupModal);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/AddGuestGroupModalV2.jsx